<script lang="ts">
	/**
	 * Timestamp that reads as "5m ago" but flips to the exact date on click.
	 *
	 * Relative ages scan far faster in dense lists, yet people occasionally need
	 * the real timestamp — so rather than picking one, this makes it a toggle.
	 * The click is stopped from propagating because these almost always sit
	 * inside a clickable row or card.
	 */
	import { formatFriendlyDate, formatRelativeDate } from '../Utilities';

	let className: string = '';
	export { className as class };

	/** The instant to display. `null` renders the `noDateText` fallback. */
	export let date: Date | string | null = null;

	/** Two-way bindable — start absolute by passing `isRelative={false}`. */
	export let isRelative: boolean = true;

	/** Text size. Omit to inherit from the surrounding element. */
	export let size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined = undefined;

	/** Shown when `date` is null. */
	export let noDateText: string = 'No date set';

	const textClasses: Record<string, string> = {
		xs: 'text-xs',
		sm: 'text-sm',
		md: 'text-base',
		lg: 'text-lg',
		xl: 'text-xl'
	};

	let dateObject: Date | null = null;
	let relativeDate: string | null = null;
	let absoluteDate: string | null = null;

	$: {
		dateObject = date ? (date instanceof Date ? date : new Date(date)) : null;
		relativeDate = dateObject ? formatRelativeDate(dateObject) : null;
		absoluteDate = dateObject ? formatFriendlyDate(dateObject) : null;
	}
</script>

<button
	type="button"
	class="{className} {size ? textClasses[size] : ''} hover:text-primary-500"
	title={absoluteDate ?? noDateText}
	on:click={(e) => {
		e.stopPropagation();
		e.preventDefault();
		isRelative = !isRelative;
	}}
>
	{#if dateObject}
		{isRelative ? relativeDate : absoluteDate}
	{:else}
		{noDateText}
	{/if}
</button>
